import type { SSOLoginArgs } from '@dvb/common';

import { authAxios, baseAxios } from '@milestone-portal/api/client';

import type {
  GetPublicProfileArgs,
  LoginRes,
  PrivateUserProfile,
  PublicUserProfile,
  SetAvatarArgs,
  UpdateProfileArgs,
} from './auth.types';

export const logoutRequest = async () => {
  const { data } = await authAxios.post('/api/milestone/v1/auth/logout');
  return data;
};

export const getProfileRequest = async () => {
  const { data } = await authAxios.get<PrivateUserProfile>(
    '/api/milestone/v1/auth/profile'
  );
  return data;
};

export const updateProfileRequest = async (args: UpdateProfileArgs) => {
  const { data } = await authAxios.post<PrivateUserProfile>(
    '/api/milestone/v1/auth/profile',
    {
      bio: args.bio,
      custom_url: args.customUrl,
      name: args.name,
      social_links: args.socialLinks,
    }
  );
  return data;
};

export const updateAvatarRequest = async (args: FormData) => {
  const { data } = await authAxios.post<Partial<PrivateUserProfile>>(
    '/api/milestone/v1/auth/update-avatar',
    args,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return data;
};

export const getPublicProfileRequest = async (args: GetPublicProfileArgs) => {
  const { data } = await baseAxios.get<PublicUserProfile>(
    `/api/milestone/v1/auth/profile`,
    {
      params: {
        user_slug: args.userSlug,
      },
    }
  );
  return data;
};

export const ssoLoginRequest = async ({
  authCode,
  codeVerifier,
  redirectUri,
  type,
}: SSOLoginArgs) => {
  const { data } = await baseAxios.post<LoginRes>(
    '/api/milestone/v1/auth/sso',
    {
      code: authCode,
      code_verifier: codeVerifier,
      redirect_uri: redirectUri,
      type,
    }
  );
  return data;
};

export const setNftAvatarRequest = async (args: SetAvatarArgs) => {
  const { data: isSuccess } = await authAxios.post<boolean>(
    '/api/milestone/v1/auth/set-nft-avatar',
    {
      nft_id: args.nftId,
    }
  );
  return isSuccess;
};
